import $ from 'jquery'
import 'superfish'
import 'jquery.mmenu'

const main_menu = $('#menu-main-navigation')
const main_menu_clone = main_menu.clone()

$.each(main_menu.find('> li'), function(index, item) {
	// If top level nav item add class top-level
	// to be used later to figure out what is a
	// top level item
	$(item).addClass('top-level')
})

main_menu
	.superfish({
		delay: 500,
		speed: 100,
		onShow: function() {
			const dropdown = $(this)
			const offset = dropdown.offset()
			const left = offset.left
			const width = dropdown.width()
			const docWidth = $(window).width()

			if (!width) return

			const isEntirelyVisible = left + width <= docWidth

			if (!isEntirelyVisible) {
				dropdown.addClass('out-of-bounds')
			}
		},
	})
	.show()

/*************** MMenu/Mobile Menu ***************/
$('body').append(
	`<div id="mobile_menu_js"><ul>${main_menu_clone[0].innerHTML}</ul></div>`
)

const mobile_menu = $('#mobile_menu_js')
const mobile_toggle = $('#mobile_toggle_js')

mobile_menu.mmenu({
	extensions: ['position-right'],
	counters: true,
	slidingSubmenus: true,
	navbars: [
		{
			position: 'top',
		},
	],
})

// Get plugin API instance
const API = mobile_menu.data('mmenu')

/**
 * Switch state of mobile menu
 * toggle button when clicked
 */
mobile_toggle.on('click', function(event) {
	event.preventDefault()

	$(this).toggleClass('is-active')
	API.open()
})

/**
 * Switch mobile menu toggle button state
 * when the menu overlay is clicked
 */
$('.mm-page__blocker').on('click mousedown touchstart', function() {
	mobile_toggle.removeClass('is-active')
})

/**
 * Use foundation to check the media queries change,
 * when they are set above the small breakpoint
 * close the mobile menu.
 */
$(window).on('changed.zf.mediaquery', function(event, newSize) {
	if (newSize === 'xlarge') {
		API.close()
	}
})
